import { theme, parse } from "@config/theme";
import { css } from "linaria";
import { rem } from "polished";
export const spacer = "s1vy27mo";
export const container = parse({
  bg: "black",
  position: {
    _: "fixed",
    medium: "relative"
  }
}, "c1wjcm59");
export const grid = parse({
  display: "grid",
  pt: {
    _: "12",
    medium: "16",
    large: "20"
  },
  pb: {
    _: "8",
    medium: "16",
    large: "20"
  }
}, "g39jgfs");
export const logoContainer = parse({
  display: {
    medium: "flex"
  },
  alignItems: "center",
  justifyContent: "center"
}, "l1uxqmmu");
export const logo = "l1ei4sy3";
export const navLeft = parse({
  display: {
    _: "none",
    medium: "flex"
  },
  alignItems: "center",
  justifyContent: {
    medium: "flex-end",
    large: "flex-start"
  }
}, "n5zl9jm");
export const navRight = parse({
  display: {
    _: "none",
    medium: "flex"
  },
  alignItems: "center",
  justifyContent: {
    medium: "flex-start",
    large: "flex-end"
  }
}, "no6t8ay");
export const navLink = parse({
  fontFamily: "artegra",
  fontWeight: "medium",
  position: "relative"
}, "n1agreck");
export const toggleButton = parse({
  fontFamily: "artegra",
  fontWeight: "medium",
  position: "relative"
}, "tmlb055");
export const toggleButtonContainer = parse({
  display: {
    _: "flex",
    medium: "none"
  },
  alignItems: "center",
  justifyContent: "flex-end"
}, "t1x8i6yz");

require("./styles.linaria.module.css!=!../../../node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");